export default "{\n    \"selfServiceLabel\": \"Self-service plan\",\n    \"managedByResqLabel\": \"Managed by ResQ\"\n}\n"